import { DATETIME_UNIT } from '@ricoh/ria.client.core/constants/core/unit';
import { Url } from '@ricoh/ria.client.core/utils/es/url';

const globalThisCore = globalThis as GlobalThisCore;

/**
 * Expose Window.
 *
 * @param {string} key Key.
 * @param {unknown} module Module.
 */
export function exposeWindow(key: string, module: unknown) {
  if (import.meta.env.PROD) {
    return;
  }

  globalThisCore.lab.module = {
    ...globalThisCore.lab.module,
    [key]: module,
  };
}

/**
 * Go to debugger mode.
 *
 * @param {number} delay Delay time.
 */
export function debug(delay: number = 3000) {
  setTimeout(() => {
    // * Use debugger mode for lab plugin
    // eslint-disable-next-line no-debugger
    debugger;
  }, delay);
}

/**
 * Create temp url.
 *
 * @param {File | Blob} object Object to create url.
 * @param {number} duration Duration to revoke url.
 *
 * @returns {string | undefined} Temp url.
 */
export function createTempUrl(object: File | Blob, duration: number = 1 * DATETIME_UNIT.MINUTE): string | undefined {
  if (import.meta.env.PROD) {
    return undefined;
  }

  const url = Url.createObjectURL(object);
  setTimeout(() => {
    Url.revokeObjectURL(url);
  }, duration);

  return url;
}
